import { AdBaseData } from './useAdBaseData';
import { useRelatedAds } from '@/hooks/useRelatedAds';
import { AdStatus } from '@/types';

export function useAdRelatedData(
  adBaseData: AdBaseData,
  isAuthor: boolean,
  isShop: boolean
) {
  const { relatedAds, loading: relatedAdsLoading } = useRelatedAds();

  const relatedAdsList = relatedAds?.nodes ?? [];
  const { Published } = AdStatus;
  const isBrowser = typeof window !== 'undefined';
  const { adData, status, currentCategory } = adBaseData;
  const isRelatedAdsVisible =
    (status === Published || !isAuthor) &&
    (relatedAdsList.length > 0 || relatedAdsLoading || !isBrowser);
  const relatedAdsHasNextPage = !!relatedAds?.pageInfo?.hasNextPage;
  const hasShowAllLink =
    (isShop && status === Published) || relatedAdsHasNextPage;
  const currentCategoryPath = currentCategory?.path ?? '';
  const relatedAdsShowAllLink = hasShowAllLink
    ? isShop && status === Published
      ? adData?.shop?.uri
      : currentCategoryPath
      ? `/${currentCategoryPath}`
      : undefined
    : undefined;

  return {
    relatedAdsList,
    relatedAdsLoading,
    isRelatedAdsVisible,
    hasShowAllLink,
    relatedAdsShowAllLink,
  };
}
